export default "__VITE_ASSET__Cshgi5qt__"